import React, { FC } from 'react';
import Logo from '../../components/svgs/logo';

const PageTerms: FC = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '48px 24px', fontFamily: 'var(--primaryFont, Inter, sans-serif)' }}>
      <div style={{ marginBottom: '48px' }}>
        <Logo size="340px" type="logoWithTitle" />
      </div>

      <h1 style={{ fontSize: '1.5rem', fontWeight: 500, color: 'var(--gray-900)', marginBottom: '8px' }}>
        Användaravtal för Leverantörer
      </h1>
      <p style={{ fontSize: '0.875rem', color: 'var(--gray-500)', marginBottom: '32px' }}>
        Senast uppdaterad: 2026-03-01
      </p>

      <p style={styles.intro}>
        Detta avtal reglerar användningen av Accurators tjänst ("Tjänsten"), där leverantörer kan erbjuda sina tjänster till företag och föreningar. All information om betalning gäller enbart för tilläggstjänster och är inte ett krav för att skapa ett konto.
      </p>

      <Section title="1. Allmänt">
        Aceve Sverige AB, organisationsnummer 556944-2501, tillhandahåller en digital plattform som möjliggör upphandling av tjänster från leverantörer.
      </Section>

      <Section title="2. Fullmakt för köp av tilläggstjänster">
        Genom att acceptera detta avtal intygar leverantören att alla användare kopplade till deras konto, inklusive anställda utan firmateckningsrätt, har fullmakt att genomföra köp av frivilliga tilläggstjänster.
      </Section>

      <Section title="3. Köprättigheter och Betalningar">
        Tilläggstjänster är frivilliga och kräver separat betalning enligt gällande pris som presenteras i systemet. Vid utebliven betalning har Accurator rätt att stänga av tilläggstjänster.
      </Section>

      <Section title="4. Ansvar">
        <p style={styles.paragraph}>
          Leverantören ansvarar för att all information de lämnar är korrekt och laglig.
        </p>
        <p style={styles.paragraph}>
          Leverantören ansvarar för vilka användare de bjuder in till sitt konto. Dessa användare kan få tillgång till förfrågningar kopplade till leverantören. Leverantören ansvarar för att hålla sin användarlista uppdaterad med aktuella användare.
        </p>
        <p style={styles.paragraph}>
          Användare kopplade till leverantören har rätt att ändra företagspresentationen.
        </p>
      </Section>

      <Section title="5. Personuppgifter">
        Se{' '}
        <a href="https://www.accurator.se/sidor/gdpr" target="_blank" rel="noopener noreferrer" style={styles.link}>
          https://www.accurator.se/sidor/gdpr
        </a>.
      </Section>

      <Section title="6. Användning av uppladdad information">
        Leverantören godkänner att Accurator får ta del av och använda information som laddas upp i Tjänsten, inklusive men inte begränsat till dokument, intyg och uppgifter kopplade till leverantörens konto. Accurator kan dela sådan information med sina samarbetspartners.
      </Section>

      <Section title="7. Avtalsändringar">
        Accurator kan göra ändringar i avtalet. Vid väsentliga ändringar informeras leverantören minst en månad i förväg.
      </Section>

      <Section title="8. Uppsägning">
        Avtalet och kontot kan avslutas omgående. Om leverantören har pågående tilläggstjänster, avslutas dessa först efter den köpta avtalsperioden är slut.
      </Section>

      <Section title="9. Tillämplig lag">
        Avtalet styrs av svensk lag och eventuella tvister löses i första hand genom förhandling och i andra hand av Stockholms tingsrätt.
      </Section>

      <div style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid var(--gray-200)' }}>
        <p style={{ fontSize: '0.75rem', color: 'var(--gray-500)' }}>
          Aceve Sverige AB - Org.nr 556944-2501
        </p>
      </div>
    </div>
  );
};

const Section: FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div style={{ marginBottom: '24px' }}>
    <h2 style={styles.sectionTitle}>{title}</h2>
    <div style={styles.sectionBody}>{children}</div>
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  intro: { fontSize: '0.875rem', color: 'var(--gray-700)', lineHeight: 1.6, marginBottom: '32px' },
  sectionTitle: { fontSize: '1rem', fontWeight: 500, color: 'var(--gray-900)', marginBottom: '8px' },
  sectionBody: { fontSize: '0.875rem', color: 'var(--gray-700)', lineHeight: 1.6 },
  paragraph: { marginBottom: '8px' },
  link: { color: 'var(--orange-500)', textDecoration: 'underline' },
};

export default PageTerms;
